import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DictionaryEvidence,
  FormTextArea,
  FormTextField,
} from '@eas/common-web';
import { useCommonHistoryDescriptors } from '@composite/history/history-common-descriptors';
import { HistoryField } from '@composite/history/history-field';

export function Fields() {
  const historyDescriptors = useCommonHistoryDescriptors();

  return (
    <>
      <FormTextArea
        name="name"
        required
        label={
          <FormattedMessage
            id="ES__DICT_REGULATION_ORDERS__DETAIL__FIELD_LABEL__NAME"
            defaultMessage="Název"
          />
        }
      />
      <DictionaryEvidence.FieldCode />
      <FormTextField
        name="regulationOrder"
        label={
          <FormattedMessage
            id="ES__DICT_REGULATION_ORDERS__DETAIL__FIELD_LABEL__REGULATION_ORDER"
            defaultMessage="Pořadí indexu"
          />
        }
      />
      <FormTextField
        name="number"
        label={
          <FormattedMessage
            id="ES__DICT_REGULATION_ORDERS__DETAIL__FIELD_LABEL__NUMBER"
            defaultMessage="Číslo"
          />
        }
        required
      />
      <FormTextField
        name="year"
        label={
          <FormattedMessage
            id="ES__DICT_REGULATION_ORDERS__DETAIL__FIELD_LABEL__YEAR"
            defaultMessage="Rok"
          />
        }
        required
      />
      <DictionaryEvidence.FieldActive />
      <HistoryField
        descriptors={[
          ...historyDescriptors,
          { key: 'regulationOrder', label: 'Pořadí indexu' },
        ]}
      />
    </>
  );
}
